// extracted by mini-css-extract-plugin
export default {"textIcon":"MultiText_textIcon__QFuh5","cancelIcon":"MultiText_cancelIcon__aw5y-","submitIcon":"MultiText_submitIcon__vqcGn"};